/** Meta Embedded Signup finish event for WhatsApp Business App coexistence. */
export const WA_EMBEDDED_SIGNUP_TYPE = 'WA_EMBEDDED_SIGNUP';
export const WA_COEXISTENCE_FINISH_EVENT =
  'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING';

const envAppId = () =>
  (import.meta.env.VITE_META_APP_ID as string | undefined)?.trim();
const envConfigId = () =>
  (
    import.meta.env.VITE_WHATSAPP_COEXISTENCE_CONFIG_ID as string | undefined
  )?.trim();

export const resolveWhatsAppCoexistenceConfig = (): {
  appId: string;
  configId: string;
} => {
  const appId = envAppId() || '';
  const configId = envConfigId() || '';

  if (!appId || !configId) {
    throw new Error(
      'WhatsApp Business App connect is not configured. Please try again later.'
    );
  }

  return { appId, configId };
};

export const isFacebookOrigin = (origin: string): boolean =>
  origin === 'https://facebook.com' ||
  origin === 'https://www.facebook.com' ||
  origin === 'https://web.facebook.com' ||
  origin.endsWith('.facebook.com');

export const parseWhatsAppCoexistenceWabaId = (
  event: MessageEvent
): string | null => {
  if (typeof event.origin !== 'string' || !isFacebookOrigin(event.origin)) {
    return null;
  }

  let payload: unknown = event.data;
  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload);
    } catch {
      return null;
    }
  }

  if (!payload || typeof payload !== 'object') return null;

  const data = payload as {
    type?: string;
    event?: string;
    data?: { waba_id?: string; wabaId?: string };
  };

  if (data.type !== WA_EMBEDDED_SIGNUP_TYPE) return null;
  if (data.event !== WA_COEXISTENCE_FINISH_EVENT) return null;

  const wabaId = data.data?.waba_id?.trim() || data.data?.wabaId?.trim();
  return wabaId || null;
};

export const launchWhatsAppCoexistenceSignup = (
  configId: string,
  onCode: (code: string) => void,
  onCancel: () => void
) => {
  if (!window.FB) {
    onCancel();
    return;
  }

  window.FB.login(
    (response) => {
      const code = response.authResponse?.code?.trim();
      if (!code) {
        onCancel();
        return;
      }
      onCode(code);
    },
    {
      config_id: configId,
      response_type: 'code',
      override_default_response_type: true,
      extras: {
        setup: {},
        featureType: 'whatsapp_business_app_onboarding',
        sessionInfoVersion: 3,
      },
    }
  );
};
